import { useState } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { ConfirmationDialog } from "../../../shared/components";
import { useChatSettingsManager } from "../hooks/use-chat-settings-manager";
import { ChatSettings } from "./chat-settings";
import { useSettings } from "../settings-context";

interface SettingsDialogProps {
  open: boolean;
  setClose: () => void;
}

export const SettingsDialog = ({ open, setClose }: SettingsDialogProps) => {
  const { chatSettings, setChatSettings } = useSettings();

  const {
    tempSettings,
    handleChange,
    settingsChanged,
    resetTempSettings,
    saveSettings,
  } = useChatSettingsManager(chatSettings, setChatSettings);

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const handleCancel = () => {
    if (settingsChanged) {
      setCancelDialogOpen(true);
    } else {
      setClose();
    }
  };
  const handleSave = () => {
    saveSettings();
    setClose();
  };
  const handleConfirmCancel = () => {
    setCancelDialogOpen(false);
    setClose();
    resetTempSettings();
  };

  return (
    <>
      <Dialog open={open} onClose={handleCancel} maxWidth="lg" fullWidth>
        <DialogTitle>Chatbot Settings</DialogTitle>
        <DialogContent>
          <ChatSettings
            tempSettings={tempSettings}
            handleChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={handleCancel}
              color="secondary"
              sx={{
                ml: 2,
                mb: 1,
              }}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSave}
              sx={{
                mr: 2,
                mb: 1,
              }}
            >
              Save
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={cancelDialogOpen}
        onClose={() => setCancelDialogOpen(false)}
        onConfirm={handleConfirmCancel}
        onDeny={() => setCancelDialogOpen(false)}
        question={"Are you sure you want to discard all changes?"}
        title={"Discard Changes?"}
      />
    </>
  );
};
